import {
    IDatabaseBleed,
    IEditorElementCollection,
    IEditorImage,
    IEditorPage,
    IEditorThumb,
    IPage,
    ISize, SF
} from "./interfaces";
import {EditorHelpers} from "@/editor/base/helpers";
import {ImagingUtils} from "@/helpers/imaging-utils";
import {ThumbSize} from "@/editor/base/models-base";


interface IEditorThumbWithImage extends IEditorThumb {
        image:string;
    }

    class EditorImage implements IEditorImage {

        private static idCount:number = 1;
        public edits: { rotation?: number; autocorrect?: boolean };
        public height: number;
        public id: number;
        public name: string;
        public pathPrefix: string;
        public thumbs:  {[key: string]: IEditorThumbWithImage};
        public urlPrefix: string;
        public width: number;

        constructor(img:HTMLImageElement, filename:string) {
            this.edits = {};
            this.id = EditorImage.idCount++;
            this.height = img.height;
            this.width = img.width;
            this.name = filename;
            this.pathPrefix = '';
            this.urlPrefix = '';
            const mediumSize = EditorHelpers.getImageSizeFromMax(img.width, img.height, 750);
            const xLargeSize = EditorHelpers.getImageSizeFromMax(img.width, img.height, 1280);
            const mediumImage = this.getThumbImage(img, mediumSize);
            const xLargeImage = this.getThumbImage(img, xLargeSize);

            this.thumbs = {
                full: {
                    name: 'full',
                    width: this.width,
                    height: this.height,
                    image: img.src
                },
                medium: {
                    name: 'medium',
                    width: mediumSize.width,
                    height: mediumSize.height,
                    image: mediumImage
                },
                xlarge: {
                    name: 'xlarge',
                    width: xLargeSize.width,
                    height: xLargeSize.height,
                    image: xLargeImage
                }
            };
        }

        private getThumbImage(img: HTMLImageElement, thumbSize: ISize): string {
            let thumbImage = ImagingUtils.drawImageWithCrop(img, {
                x: 0,
                y: 0,
                width: thumbSize.width,
                height: thumbSize.height
            }, {
                x: 0,
                y: 0,
                width: img.width,
                height: img.height
            }, 90, 'png');
            if (!thumbImage) {
                thumbImage = img.src;
                thumbSize.width = img.width;
                thumbSize.height = img.height;
            }
            return thumbImage;
        }

        getThumb(thumb: string): IEditorThumbWithImage {
            switch (thumb) {
                case ThumbSize.XLARGE:
                case ThumbSize.LARGE:
                    return this.thumbs.xlarge;
                case ThumbSize.MEDIUM:
                case ThumbSize.SMALL:
                    return this.thumbs.medium;
                case ThumbSize.FULL:
                default:
                    return this.thumbs.full;
            }

        }

        getUrl(thumbName: string, hasAutoCorrect?: boolean, hasAutoRedEye?: boolean): string {
            switch (thumbName) {
                case ThumbSize.XLARGE:
                    return this.thumbs.xlarge.image;
                case ThumbSize.MEDIUM:
                case ThumbSize.SMALL:
                    return this.thumbs.medium.image;
                case ThumbSize.FULL:
                default:
                    return this.thumbs.full.image;
            }
        }

    }

    export class Renderer {
        private static editorImages: {[key:number]:EditorImage} = {};
        public static toPage(page: IPage, pageLabels: string[]|undefined, bleedData?: IDatabaseBleed): IEditorPage {
            return (SF.Util as any).Edits.toPage(page, pageLabels, bleedData);
        }

        public static toCollection(pages: IEditorPage[], showingIndex?: number): IEditorElementCollection {
            return new SF.Model.ElementCollection(pages, showingIndex);
        }

        public static getEditorImageFromImage(img:HTMLImageElement, filename: string):IEditorImage {

            const editorImage = new EditorImage(img, filename);
            this.editorImages[editorImage.id] = editorImage;
            return editorImage;
        }

        public static removeEditorImage(imageId:number):void {
            delete this.editorImages[imageId];
        }

        public static getEditorImage(imageId:number):EditorImage {
            return this.editorImages[imageId];
        }

        public static clearAllImages():void {
            this.editorImages = {};
        }
    }
